
import { React, useState, useEffect } from "react";
import icons from "../../../icons.config";
import { IMAGE_BASE_URL } from "../../../api-urls";

const Founder = ({ data }) => {
  const {
    content_images = [],
    name_title = "Default Title",
    name_title_color = "white",
    title_description = "Default Description",
    title_description_color = "white",
  } = data || {};

  const imageList = content_images.map((img) => ({
    original: img,
    gImage: img,
  }));

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isFading, setIsFading] = useState(false);

  const updateImages = () => {
    setIsFading(true);
    setTimeout(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % imageList.length);
      setIsFading(false);
    }, 500);
  };

  useEffect(() => {
    if (imageList.length > 0) {
      const interval = setInterval(updateImages, 5000); // Changed to 5 seconds
      return () => clearInterval(interval);
    }
  }, [imageList]);

  if (!data) {
    return null;
  }

  return (
    <section className="relative bg-primary2 pt-[5%] pb-[40%] md:py-[12%] lg:py-0 z-1 bottom-0 md:px-8 xl:px-2 overflow-hidden">
      {/* Pattern Overlay */}
      <div
        className="absolute inset-0 z-10 bg-cover h-[90%] bg-center pointer-events-none overflow-hidden"
        style={{
          backgroundImage: `url(${icons.brandPattern})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          top: "4%",
          left: "3%",
          right: "3%",
          bottom: "4%",
          width: "94%",
          height: "92%",
        }}
      />
      <div className="relative top-16 md:top-12 lg:top-0">
        <h3
          className="text-xl md:text-3xl lg:hidden flex justify-center font-outfit font-light mb-4 relative bottom-5 md:bottom-12"
          style={{ color: `#${name_title_color}` }}
        >
          {name_title}
        </h3>

        {/* Image for small screens */}
        {imageList.length > 0 && (
          <div className="flex justify-center items-center lg:hidden z-20">
            <div className="w-[77%] md:w-[95%] h-[400px] md:h-[500px]">
              <img
                src={IMAGE_BASE_URL + imageList[currentIndex]?.original}
                alt="Founder"
                className="w-full h-full object-cover animate-dissolve transition-opacity duration-500"
                onError={(e) => console.error("Image failed to load:", e.target.src)}
              />
            </div>
          </div>
        )}

        {/* Content Section */}
        <div className="container relative  px-3 flex flex-col lg:flex-row items-center z-20 mt-16 lg:mt-0">
          {/* Text Section */}
          <div className="lg:w-1/2 text-center relative lg:left-16 xl:left-28">
            <h3
              className="text-xl hidden lg:block lg:text-3xl justify-center font-outfit font-light mb-10"
              style={{ color: `#${name_title_color}` }}
            >
              {name_title}
            </h3>
            <h2 className="text-3xl md:text-5xl lg:text-5xl font-outfit font-medium text-white mb-12">
              JIYA BENIWAL
            </h2>
            <h5
              className="text-md font-poppins font-medium mb-4 px-4 md:px-0"
              style={{ color: `#${title_description_color}` }}
            >
              {title_description}
            </h5>
            <p className="font-poppins font-light text-hcolor text-sm md:text-base px-5 lg:px-0">
              Our mission is to provide premium, customizable fit that empowers
              everyone to express their unique identity and style while enjoying
              the luxury of exquisite fits and premium fabrics.
            </p>
          </div>

          {/* Image Section for Larger Screens */}
          {imageList.length > 0 && (
            <div className="w-full max-w-5xl lg:w-1/2 lg:relative lg:top-10 lg:left-28 md:pr-0 lg:pr-[12%] xl:pr-[3%] overflow-hidden mb-8 pb-10">
              {/* Single Image Carousel for Large Screens */}
              <div className="hidden lg:flex justify-center items-center">
                <div className="w-[80%] xl:w-[50%] h-[400px] xl:h-[400px] 2xl:h-[400px]">
                  <img
                    src={IMAGE_BASE_URL + imageList[currentIndex].original}
                    alt="Founder"
                    className={`w-full h-full object-cover transition-opacity duration-500  ${
                      isFading ? "opacity-0" : "opacity-100"
                    }`}
                    onError={(e) => console.error("Image failed to load:", e.target.src)}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Founder;














// import { React, useState, useEffect } from "react";
// import icons from "../../../icons.config";
// import { IMAGE_BASE_URL } from "../../../api-urls";

// const Founder = ({ data }) => {
//   const {
//     content_images = [],
//     name_title = "Default Title",
//     name_title_color = "white",
//     title_description = "Default Description",
//     title_description_color = "white",
//   } = data || {};

//   const imageList = content_images.map((img) => ({
//     original: img,
//     gImage: img,
//   }));

//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [isFading, setIsFading] = useState(false);

//   const updateImages = () => {
//     setIsFading(true);
//     setTimeout(() => {
//       setCurrentIndex((prevIndex) => (prevIndex + 1) % imageList.length);
//       setIsFading(false);
//     }, 500);
//   };

//   useEffect(() => {
//     if (imageList.length > 0) {
//       const interval = setInterval(updateImages, 3000);
//       return () => clearInterval(interval);
//     }
//   }, [imageList]);

//   if (!data) {
//     return null;
//   }

//   return (
//     <section className="relative bg-primary2 pt-[5%] pb-[40%] md:py-[12%] lg:py-0 z-1 bottom-0 md:px-8 xl:px-2 overflow-hidden">
//       {/* Pattern Overlay */}
//       <div
//         className="absolute inset-0 z-10 bg-cover h-[90%] bg-center pointer-events-none overflow-hidden"
//         style={{
//           backgroundImage: `url(${icons.brandPattern})`,
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//           top: "4%",
//           left: "3%",
//           right: "3%",
//           bottom: "4%",
//           width: "94%",
//           height: "92%",
//         }}
//       />
//       <div className="relative top-16 md:top-12 lg:top-0">
//         <h3
//           className="text-xl md:text-3xl lg:hidden flex justify-center font-outfit font-light mb-4 relative bottom-5 md:bottom-12"
//           style={{ color: `#${name_title_color}` }}
//         >
//           {name_title}
//         </h3>

//         {/* Image for small screens */}
//         {imageList.length > 0 && (
//           <div className="flex justify-center items-center lg:hidden z-20">
//             <div className="w-[77%] md:w-[95%] h-[400px] md:h-[500px]">
//               <img
//                 src={IMAGE_BASE_URL + imageList[currentIndex]?.original}
//                 alt="Founder"
//                 className="w-full h-full object-cover animate-dissolve transition-opacity duration-500"
//                 onError={(e) => console.error("Image failed to load:", e.target.src)}
//               />
//             </div>
//           </div>
//         )}

//         {/* Content Section */}
//         <div className="container relative mx-auto px-3 flex flex-col lg:flex-row items-center z-20 mt-16 lg:mt-0  ">
//           {/* Text Section */}
//           <div className="lg:w-1/2 text-center relative lg:left-28">
//             <h3
//               className="text-xl hidden lg:block lg:text-3xl justify-center font-outfit font-light mb-10"
//               style={{ color: `#${name_title_color}` }}
//             >
//               {name_title}
//             </h3>
//             <h2 className="text-3xl md:text-5xl lg:text-5xl font-outfit font-medium text-white mb-12">
//               JIYA BENIWAL
//             </h2>
//             <h5
//               className="text-md font-poppins font-medium mb-4 px-4 md:px-0"
//               style={{ color: `#${title_description_color}` }}
//             >
//               {title_description}
//             </h5>
//             <p className="font-poppins font-light text-hcolor text-sm md:text-base px-5 lg:px-0">
//               Our mission is to provide premium, customizable fit that empowers
//               everyone to express their unique identity and style while enjoying
//               the luxury of exquisite fits and premium fabrics.
//             </p>
//           </div>

//           {/* Image Section for Larger Screens */}
//           {imageList.length > 0 && (
//             <div className="grid grid-cols-2 gap-4 w-full max-w-5xl mx-auto 2xl:-mb-40 lg:relative lg:top-12 lg:left-28 md:pr-0 lg:pr-[8%] xl:pr-[3%] overflow-hidden">
//               <div className="col-span-1 justify-center hidden lg:flex z-10">
//                 <div className="w-[65%] h-[65%] relative left-32 top-6">
//                   <img
//                     src={IMAGE_BASE_URL + imageList[currentIndex].original}
//                     alt="Founder"
//                     className={`w-full h-full object-fit transition-opacity duration-500 ${
//                       isFading ? "opacity-0" : "opacity-100"
//                     }`}
//                   />
//                 </div>
//               </div>

//               <div className="col-span-1 hidden lg:flex">
//                 <div className="w-[65%] h-[65%] relative right-4 bottom-4">
//                   <img
//                     src={
//                       imageList.length > 1
//                         ? IMAGE_BASE_URL + imageList[(currentIndex + 1) % imageList.length].gImage
//                         : IMAGE_BASE_URL + imageList[currentIndex].original
//                     }
//                     alt="Founder"
//                     className={`w-full h-full object-fit transition-opacity duration-500 ${
//                       isFading ? "opacity-0" : "opacity-100"
//                     }`}
//                   />
//                 </div>
//               </div>

//               <div className="col-span-2 justify-center hidden lg:flex ">
//                 <div className="w-[33%] h-[70%] relative bottom-44 left-12">
//                   <img
//                     src={
//                       imageList.length > 2
//                         ? IMAGE_BASE_URL + imageList[(currentIndex + 2) % imageList.length].gImage
//                         : IMAGE_BASE_URL + imageList[currentIndex].original
//                     }
//                     alt="Founder"
//                     className={`w-full h-full object-fit transition-opacity duration-500 ${
//                       isFading ? "opacity-0" : "opacity-100"
//                     }`}
//                     onError={(e) => console.error("Image failed to load:", e.target.src)}
//                   />
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Founder;

